import { Link } from "react-router-dom";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import { PageHero } from "@/components/sections/PageHero";
import { FileDown, FileText, Book } from "lucide-react";

const downloads = [
  {
    title: "General Catalogue",
    description: "Complete overview of all our products, services, and turnkey project solutions.",
    fileSize: "11.7 MB",
    fileType: "PDF",
    link: "/downloads/General-Catalogue.pdf"
  },
  {
    title: "Company Profile",
    description: "Detailed information about Basupra Exim International, our history, and capabilities.",
    fileSize: "11.7 MB",
    fileType: "PDF",
    link: "/downloads/General-Catalogue.pdf"
  },
  {
    title: "Product Brochure",
    description: "Technical specifications and details of our manufacturing equipment and machinery.",
    fileSize: "11.7 MB",
    fileType: "PDF",
    link: "/downloads/General-Catalogue.pdf"
  },
  {
    title: "Project Portfolio",
    description: "Showcase of our successfully completed projects across various industries.",
    fileSize: "11.7 MB",
    fileType: "PDF",
    link: "/downloads/General-Catalogue.pdf"
  }
];

export default function Downloads() {
  return (
    <>
      <Header />
      <main>
        <PageHero title="Downloads" breadcrumb="Downloads" />
        
        <section className="py-[80px] bg-white">
          <div className="container mx-auto px-4 max-w-[1200px]">
            <div className="text-center mb-[60px] max-w-[800px] mx-auto">
              <h2 className="font-display font-bold text-[28px] text-[#001d3d] uppercase tracking-wider mb-4">
                Download Resources
              </h2>
              <p className="text-[#4a5568] text-[16px] leading-[1.6]">
                Access our catalogues, brochures, and technical documents to learn more about our products and services.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {downloads.map((item, index) => (
                <div 
                  key={index} 
                  className="bg-white border border-[#e2e8f0] rounded-lg p-8 shadow-card card-hover flex items-start gap-6"
                >
                  <div className="w-16 h-16 bg-[#f8f9fa] rounded-lg flex items-center justify-center flex-shrink-0">
                    <FileText className="w-8 h-8 text-[#17A2B8]" />
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="font-display font-bold text-[18px] text-[#001d3d] mb-2">
                      {item.title}
                    </h3>
                    <p className="text-[#4a5568] text-[14px] leading-[1.6] mb-4">
                      {item.description}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-[#4a5568] text-[13px]">
                        {item.fileType} • {item.fileSize}
                      </span>
                      <a 
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-4 py-2 bg-[#17A2B8] text-white text-[13px] font-semibold rounded-[2px] hover:bg-[#138496] transition-colors"
                      >
                        <FileDown className="w-4 h-4" />
                        Download
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-[80px] bg-[#f8f9fa]">
          <div className="container mx-auto px-4 max-w-[1200px]">
            <div className="bg-black rounded-lg p-10 md:p-16 text-center">
              <Book className="w-16 h-16 text-[#17A2B8] mx-auto mb-6" />
              <h2 className="font-display font-bold text-[28px] text-white uppercase tracking-wider mb-4">
                Main Catalogue
              </h2>
              <p className="text-white/70 text-[16px] mb-8 max-w-[500px] mx-auto">
                Download our comprehensive catalogue containing all our products, services, and turnkey solutions.
              </p>
              <a 
                  href="/downloads/General-Catalogue.pdf"
                  download
                  className="inline-flex items-center gap-3 px-10 py-4 bg-[#17A2B8] text-white font-display font-semibold uppercase tracking-wider rounded-[2px] hover:bg-[#138496] transition-colors"
                >
                <FileDown className="w-5 h-5" />
                Download Catalogue
              </a>
            </div>
          </div>
        </section>

        <section className="py-[80px] bg-white">
          <div className="container mx-auto px-4 max-w-[1200px] text-center">
            <h2 className="font-display font-bold text-[28px] text-[#001d3d] mb-6 uppercase tracking-wider">
              Need More Information?
            </h2>
            <p className="text-[#4a5568] text-[16px] mb-8 max-w-[600px] mx-auto">
              If you need specific documents or technical specifications, please contact our team.
            </p>
            <Link 
              to="/contact" 
              className="inline-block px-10 py-4 border-2 border-[#001d3d] text-[#001d3d] font-display font-semibold uppercase tracking-wider rounded-[2px] hover:bg-[#001d3d] hover:text-white transition-colors"
            >
              Contact Us
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
